import { organisationConstants } from '../../../_constants';

const initialState = { getManageMetricLoading: true, data: '', error: false };

export function ManageMetricList(state = initialState, action) {
    switch (action.type) {
        case organisationConstants.REQUEST_MANAGE_METRIC_LIST:
            return {
                getManageMetricLoading: true,
                data: '',
                error: false
            };
        case organisationConstants.RECEIVE_MANAGE_METRIC_LIST:
            return {
                getManageMetricLoading: false,
                data: action.manageMetricList,
                error: false
            };
        case organisationConstants.MANAGE_METRIC_LIST_ERROR:
            return {
                getManageMetricLoading: false,
                data: '',
                error: true
            };
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/organisation/manageMetric/getManageMetricList.reducer.js